// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RW45_","label":"styles_label__4QOXB"};